<ng-container *transloco="let t;">

  <div class="p-mb-4">
    <p-card>

      <div class="p-grid p-fluid">
        <div class="p-col-3">
          <p>{{ t('move_order.labels.actual_date') }}: <strong>{{ order.start_time_admin | amDateFormat: 'DD.MM.YYYY HH:mm' }} {{ t('common.labels.oclock') }}</strong></p>
          <div class="p-grid">
            <div class="p-col-fixed" style="width: 60px;">
              <p-inputSwitch [(ngModel)]="dateActive" tabindex="0" (onChange)="dateActiveChanged()"></p-inputSwitch>
            </div>
            <div class="p-col">
              {{ t('move_order.labels.change_date') }}
            </div>
          </div>
          <app-form-control [cid]="'date'" [control]="subForm.get('date')" [type]="'date'" [label]="t('move_order.labels.new_date') + getDstLabel()"></app-form-control>
        </div>
        <div class="p-col-3">
          <p>{{ t('move_order.labels.actual_location') }}: <strong>{{ order.locationName }}</strong></p>
          <div class="p-grid">
            <div class="p-col-fixed" style="width: 60px;">
              <p-inputSwitch [(ngModel)]="locationActive" tabindex="0" (onChange)="locationActiveChanged()"></p-inputSwitch>
            </div>
            <div class="p-col">
              {{ t('move_order.labels.change_location') }}
            </div>
          </div>
          <app-form-control [cid]="'location'" [control]="subForm.get('location')" [type]="'select'" [options]="locations" optionLabel="name" [label]="t('move_order.labels.new_location')"></app-form-control>
        </div>
        <div class="p-col-6" *ngIf="locationDetailsVisible === true">
          <p>{{ t('common.labels.details') }}:</p>
          <div class="p-grid">
            <ng-container *ngIf="formMode === FormModes.Virtual">
              <div class="p-col-12">
                <app-country-timezone [required]="formMode === FormModes.Virtual" [(country)]="country" [(timezone)]="timezone" [form]="subForm.get('tz')" [edit]="true"></app-country-timezone>
              </div>
              <ng-container *ngIf="hasPrebriefing()">
                <div class="p-col-6">
                  <app-form-control [cid]="'prebriefing_url'" [control]="subForm.get('prebriefing_url')" [type]="'input'" [label]="t('common.labels.prebriefing_url')"></app-form-control>
                </div>
                <div class="p-col-6">
                  <app-form-control [cid]="'prebriefing_info'" [control]="subForm.get('prebriefing_info')" [type]="'input'" [label]="t('common.labels.prebriefing_info')"></app-form-control>
                </div>
              </ng-container>
              <div class="p-col-6">
                <app-form-control [cid]="'conference_url'" [control]="subForm.get('conference_url')" [type]="'input'" [label]="t('common.labels.conference_url')"></app-form-control>
              </div>
              <div class="p-col-6">
                <app-form-control [cid]="'conference_info'" [control]="subForm.get('conference_info')" [type]="'input'" [label]="t('common.labels.conference_info')"></app-form-control>
              </div>
            </ng-container>
            <ng-container *ngIf="formMode === FormModes.Onsite">
              <div class="p-col-6">
                <app-form-control [cid]="'room1'" [control]="subForm.get('room1')" [type]="'select'" [options]="roomsMain" optionLabel="name" [label]="t('common.labels.room_main')" [filter]="true" [showClear]="true"></app-form-control>
              </div>
              <div class="p-col-6">
                <app-form-control [cid]="'room2'" [control]="subForm.get('room2')" [type]="'select'" [options]="roomsPreparation" optionLabel="name" [label]="t('common.labels.room_preparation')" [filter]="true" [showClear]="true"></app-form-control>
              </div>
            </ng-container>
            <ng-container *ngIf="formMode === FormModes.Norooms">
              <div class="p-col-6">
                <app-form-control [cid]="'room_main'" [control]="subForm.get('room_main')" [type]="'input'" [label]="t('common.labels.room_main')" [placeholder]="t('common.labels.room_street_number')"></app-form-control>
              </div>
              <div class="p-col-6">
                <app-form-control [cid]="'room_preparation'" [control]="subForm.get('room_preparation')" [type]="'input'" [label]="t('common.labels.room_preparation')" [placeholder]="t('common.labels.room_street_number')"></app-form-control>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

    </p-card>
  </div>

</ng-container>
